import ManagerVoucherCampaign from './ManagerVoucherCampaign.container';

export default ManagerVoucherCampaign;
